import { render, staticRenderFns } from "./PublishPageAttachments.vue?vue&type=template&id=bbd5f322&scoped=true"
import script from "./PublishPageAttachments.vue?vue&type=script&lang=js"
export * from "./PublishPageAttachments.vue?vue&type=script&lang=js"
import style0 from "./PublishPageAttachments.vue?vue&type=style&index=0&id=bbd5f322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd5f322",
  null
  
)

export default component.exports